(function () {
  const root = document.querySelector("[data-cart-root]");
  if (!root) return;

  let updating = false;

  async function changeLine(line, quantity) {
    if (updating) return;
    updating = true;
    root.classList.add("isolated-cart--updating");
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line, quantity })
      });
      if (!response.ok) throw new Error("Cart update failed");
      window.location.reload();
    } catch (error) {
      root.classList.remove("isolated-cart--updating");
      updating = false;
      window.alert("The cart could not be updated. Please try again.");
    }
  }

  root.querySelectorAll("[data-cart-action]").forEach((button) => {
    button.addEventListener("click", () => {
      const item = button.closest("[data-cart-line]");
      if (!item) return;
      const line = Number(item.getAttribute("data-cart-line"));
      const current = Number(item.getAttribute("data-quantity"));
      const action = button.getAttribute("data-cart-action");
      const next = action === "increase" ? current + 1 : action === "decrease" ? Math.max(0, current - 1) : 0;
      changeLine(line, next);
    });
  });

  const volumeOffer = root.querySelector("[data-cart-upsell]");
  volumeOffer?.addEventListener("click", () => {
    changeLine(Number(volumeOffer.getAttribute("data-cart-line")), Number(volumeOffer.getAttribute("data-cart-quantity")));
  });

  const discountForm = root.querySelector("[data-discount-form]");
  discountForm?.addEventListener("submit", (event) => {
    event.preventDefault();
    const input = discountForm.querySelector('input[name="discount"]');
    const code = input?.value.trim();
    if (!code) return;
    const redirect = encodeURIComponent("/cart?view=sarmali-family-prayer-rug");
    window.location.assign(`/discount/${encodeURIComponent(code)}?redirect=${redirect}`);
  });
})();
